import { forwardRef, type ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

/**
 * The one button. Primary is the brand-blue action; secondary is white with a
 * border; ghost is a blue text button; danger is white with red text.
 */
export const Button = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant; size?: 'sm' | 'md' }
>(function Button({ variant = 'primary', size = 'md', className = '', type = 'button', ...p }, ref) {
  const v = variant === 'secondary' ? '' : `btn-${variant}`;
  return <button ref={ref} type={type} {...p} className={`btn ${v} ${size === 'sm' ? 'btn-sm' : ''} ${className}`.trim()} />;
});
